export default {"src":"/_next/static/media/medium-square-icon.bdc40000.svg","height":512,"width":512};